export default __webpack_public_path__ + "static/experienceImg1-ebc8114824373dd283ae5be84f10074f.png";